document.addEventListener('DOMContentLoaded', function() {
    //////////////////////////////////////////////////////////////// PRODUCT PAGE - START /////////////////////////////////////////////////////////////////

    function improveRatingButtons() {
        const initAppioExclusiveAccess = () => {
        const allContainers = document.querySelectorAll('.appio-rating-line-qty.appio-col3');
        
        allContainers.forEach(container => {
            const trigger = container.querySelector('span');
            if (!trigger || container.hasAttribute('data-acc-initialized')) return;

            container.setAttribute('data-acc-initialized', 'true');
            const isZero = trigger.textContent.trim() === '0%';

            trigger.setAttribute('role', 'button');
            
            if (isZero) {
            trigger.setAttribute('aria-disabled', 'true');
            trigger.style.cursor = 'not-allowed';
            } else {
            trigger.setAttribute('aria-pressed', 'false');
            trigger.setAttribute('tabindex', '0');
            }

            const deactivateOthers = (currentTrigger) => {
            allContainers.forEach(c => {
                const otherTrigger = c.querySelector('span');
                if (otherTrigger && otherTrigger !== currentTrigger) {
                if (otherTrigger.getAttribute('aria-disabled') !== 'true') {
                    otherTrigger.setAttribute('aria-pressed', 'false');
                }
                }
            });
            };

            const handleInteraction = (e) => {
            if (isZero) return;

            if (e.type === 'keydown' && e.key === ' ') e.preventDefault();

            const isPressed = trigger.getAttribute('aria-pressed') === 'true';

            if (!isPressed) {
                deactivateOthers(trigger);
                trigger.setAttribute('aria-pressed', 'true');
            } else {
                trigger.setAttribute('aria-pressed', 'false');
            }
            };

            trigger.addEventListener('click', handleInteraction);
            trigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') handleInteraction(e);
            });
        });
        };

        const observer = new MutationObserver(() => {
            initAppioExclusiveAccess();
         });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    function improveRatingNumberContext() {
        const setupAverageAccessibility = () => {
        const averageBox = document.querySelector('.appio-rating-average');

        if (averageBox) {
            const hasHiddenText = averageBox.querySelector('.visually-hidden');

            if (!hasHiddenText) {
            const hiddenText = document.createElement('span');
            hiddenText.className = 'visually-hidden';
            hiddenText.textContent = ' out of 5 stars';
            
            averageBox.appendChild(hiddenText);
            } else {
            averageObserver.disconnect();
            }
        }
        };

        const averageObserver = new MutationObserver((mutations) => {
        setupAverageAccessibility();
        });

        averageObserver.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
        });
    }

    function addContextToSuscriptionButton() {
        const setupRecharge = () => {
            const learnMoreLink = document.querySelector('.learn-more');
            const rechargeBadge = document.querySelector('.recharge-badge.py-1.px-3');

            if (learnMoreLink || rechargeBadge) {
                if (learnMoreLink) {
                    learnMoreLink.style.textDecoration = 'underline';
                    learnMoreLink.setAttribute('aria-describedby', 'product_title_id');
                }

                if (rechargeBadge) {
                    const svgInside = rechargeBadge.querySelector('svg');
                    if (svgInside) {
                        svgInside.setAttribute('aria-label', 'recharge');
                        svgInside.setAttribute('role', 'img');
                    }
                }
                
                return true;
            }
            return false;
        };

        if (setupRecharge()) return;

        const observer = new MutationObserver((mutations, obs) => {
            if (setupRecharge()) {
                obs.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function improvePaginationNumbersAriaLabel() {
        const fixAppioPagination = () => {
        const buttonsContainer = document.querySelector('.appio-paging-box');
        const pagingButtons = document.querySelectorAll('.appio-paging-button[page]');
        
        if (pagingButtons.length === 0) return;
        buttonsContainer.setAttribute('aria-label', 'Review pagination');
        let totalPages = 0;
        const lastButton = document.querySelector('.appio-paging-button[last]');

        if (lastButton && lastButton.getAttribute('page')) {
            totalPages = parseInt(lastButton.getAttribute('page'), 10);
        } else {
            const pages = Array.from(pagingButtons).map(b => parseInt(b.getAttribute('page'), 10) || 0);
            totalPages = Math.max(...pages);
        }

        if (totalPages <= 0) return;

        pagingButtons.forEach(btn => {
            const pageNum = btn.getAttribute('page');
            const targetLabel = `Go to page ${pageNum} of ${totalPages}`;
            
            if (btn.getAttribute('aria-label') !== targetLabel) {
            btn.setAttribute('aria-label', targetLabel);
            }
        });
        };

        const paginationObserver = new MutationObserver((mutations) => {
        clearTimeout(window.appioPaginationTimeout);
        window.appioPaginationTimeout = setTimeout(fixAppioPagination, 100);
        });

        paginationObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['page', 'class']
        });
    }

    function productImgModalAlt() {
        const updateModalMediaAlts = () => {
        // Buscamos el contenedor padre específico que proporcionaste
        const modalContent = document.querySelector('.product-media-modal__content');

            if (modalContent) {
                const images = modalContent.querySelectorAll('img');
                const totalImages = images.length;

                if (totalImages > 0) {
                    images.forEach((img, index) => {
                        const targetAlt = `product image ${index + 1} of ${totalImages}`;
                        
                        // Solo actualizamos si el alt actual es diferente para evitar ciclos
                        if (img.getAttribute('alt') !== targetAlt) {
                            img.setAttribute('alt', targetAlt);
                        }
                    });
                }
            }
        };

        // --- MutationObserver para detectar la apertura del modal ---
        const modalObserver = new MutationObserver((mutations) => {
            // Si hay cambios en el DOM, verificamos si el modal está presente y actualizamos
            updateModalMediaAlts();
        });

        // Observamos el body ya que el modal suele inyectarse al final del documento
        modalObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }


    ////Execution zone
    improveRatingButtons();
    improveRatingNumberContext();
    addContextToSuscriptionButton();
    improvePaginationNumbersAriaLabel();
    productImgModalAlt();

    //////////////////////////////////////////////////////////////// PRODUCT PAGE - END ///////////////////////////////////////////////////////////////////

    //////////////////////////////////////////////////////////////// OUR STORY - START /////////////////////////////////////////////////////////////////
    function addListSemanticsOurStory() {
        const fixPageFlySlider = () => {
            const sliders = document.querySelectorAll('.pf-slider.pf-c-ct.pf-r-eh:not([data-semantic-ready])');

            sliders.forEach(slider => {
                slider.setAttribute('data-semantic-ready', 'true');
                slider.setAttribute('role', 'list');

                const slides = slider.querySelectorAll('.pf-slide');

                slides.forEach(slide => {
                    slide.setAttribute('role', 'listitem');

                    const heading = slide.querySelector('h3');
                    if (heading) {
                        const newDiv = document.createElement('div');

                        Array.from(heading.attributes).forEach(attr => {
                            newDiv.setAttribute(attr.name, attr.value);
                        });

                        while (heading.firstChild) {
                            newDiv.appendChild(heading.firstChild);
                        }

                        heading.parentNode.replaceChild(newDiv, heading);
                    }
                });
            });
        };

        const pfObserver = new MutationObserver(() => {
            fixPageFlySlider();
        });

        pfObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function addListSemanticsOurStoryTitlesGrid() {
        const fixPageFlySingleList = () => {
        const mainWrapper = document.querySelector('.list-our-story:not([data-list-fix])');
        
        if (mainWrapper) {
            mainWrapper.setAttribute('role', 'list');
            mainWrapper.setAttribute('data-list-fix', 'true');

            const allItems = mainWrapper.querySelectorAll('[data-pf-type="ContentListItem"]');
            const intermediates = mainWrapper.querySelectorAll('div:not([data-pf-type="ContentListItem"])');
            intermediates.forEach(div => {
            if (div.querySelector('[data-pf-type="ContentListItem"]')) {
                div.setAttribute('role', 'presentation');
            }
            });

            allItems.forEach((item, index) => {
            item.setAttribute('role', 'listitem');

            const itemText = item.textContent.trim().replace(/\s+/g, ' '); 
            
            //item.setAttribute('aria-label', `item ${index + 1} ${itemText}`);

            const h3 = item.querySelector('h3');
            if (h3) {
                const divReplacement = document.createElement('div');
                Array.from(h3.attributes).forEach(attr => {
                divReplacement.setAttribute(attr.name, attr.value);
                });
                while (h3.firstChild) {
                divReplacement.appendChild(h3.firstChild);
                }
                h3.parentNode.replaceChild(divReplacement, h3);
            }
            });
        }
        };

        const listObserver = new MutationObserver(() => fixPageFlySingleList());
        listObserver.observe(document.body, { childList: true, subtree: true });
    }

    function addListSemanticsToPureProvenPowerfullSection() {
            const wrapLoosePageFlyItems = () => {
            const selectors = ['.pf-25_', '.pf-32_', '.pf-39_'];
            
            const items = selectors
                .map(sel => document.querySelector(sel))
                .filter(el => el && !el.closest('[data-custom-list-wrapper]'));


            if(Array.from(items).some(item => item.classList.contains('skip'))) {
                return;
            }
            
            if (items.length > 0) {
                const wrapper = document.createElement('div');
                wrapper.setAttribute('role', 'list');
                wrapper.setAttribute('data-custom-list-wrapper', 'true');
                
                items[0].parentNode.insertBefore(wrapper, items[0]);


                items.forEach((item, index) => {
                    item.setAttribute('role', 'listitem');
                    wrapper.appendChild(item);
                });
            }
        };

        const looseItemsObserver = new MutationObserver(() => {
            wrapLoosePageFlyItems();
           // looseItemsObserver.disconnect();
        });

        looseItemsObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    function addDescribedByToHeroVideo() {
        const syncVideoLabeledBy = () => {
            const descriptionSpan = document.querySelector('.pf-21_');
            const videoBtn = document.querySelector('#press-video-btn');
            const videoElement = document.querySelector('.pf-media-video');

            if (descriptionSpan) {
                const uniqueId = 'pf-video-label-link';

                if (descriptionSpan.id !== uniqueId) {
                    descriptionSpan.id = uniqueId;
                }

                if (videoBtn) {
                    if (videoBtn.getAttribute('aria-labelledby') !== uniqueId) {
                        videoBtn.setAttribute('aria-describedby', uniqueId);
                    }
                }

                if (videoElement) {
                    if (videoElement.hasAttribute('aria-label')) {
                        videoElement.removeAttribute('aria-label');
                    }

                    if (videoElement.getAttribute('aria-labelledby') !== uniqueId) {
                        videoElement.setAttribute('aria-labelledby', uniqueId);
                    }
                    
                }
            }
        };

        const videoLabelObserver = new MutationObserver(() => {
            syncVideoLabeledBy();
        });

        videoLabelObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    ////Execution zone
    addListSemanticsOurStory();
    addListSemanticsOurStoryTitlesGrid();
    addListSemanticsToPureProvenPowerfullSection();
    addDescribedByToHeroVideo();
    //////////////////////////////////////////////////////////////// OUR STORY - END ///////////////////////////////////////////////////////////////////



    //////////////////////////////////////////////////////////////// GLOBAL - START ///////////////////////////////////////////////////////////////////
    function restoreSliderPaginationButtonsActions() {
        const fixSliderEverything = () => {
            const sliderComponents = document.querySelectorAll('slider-component');
            
            sliderComponents.forEach(component => {
                const hasCounter = component.querySelector('.slider-counter');
                const isMobile = window.innerWidth < 990;

                if (!hasCounter || !isMobile) return;

                const nextBtn = component.querySelector('[name="next"]');
                const prevBtn = component.querySelector('[name="previous"]');
                const SLIDER_ID = nextBtn?.getAttribute('aria-controls');

                if (!SLIDER_ID) return;

                const sliderList = document.getElementById(SLIDER_ID);
                const container = component.querySelector('.slider-buttons');

                if (!sliderList || !container) return;

                const currentLabel = container.querySelector('.slider-counter--current');
                const totalLabel = container.querySelector('.slider-counter--total');
                const allItems = sliderList.querySelectorAll('.grid__item, .slider__slide');
                const totalPages = allItems.length;

                if (totalLabel && totalPages > 0) totalLabel.textContent = totalPages;

                if (!component.dataset.observed) {
                    const itemVisibilityObserver = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            const item = entry.target;
                            const mainLink = item.querySelector('a');
                            const isVisible = entry.isIntersecting;
                            
                            item.setAttribute('aria-hidden', !isVisible);
                            if (mainLink) {
                                mainLink.setAttribute('tabindex', isVisible ? '0' : '-1');
                                mainLink.setAttribute('aria-hidden', !isVisible);
                            }
                        });
                    }, { root: sliderList, threshold: 0.5 });

                    allItems.forEach(item => itemVisibilityObserver.observe(item));
                    component.dataset.observed = "true";
                }

                const updateUI = () => {
                    const scrollPos = sliderList.scrollLeft;
                    const itemWidth = allItems[0]?.clientWidth || sliderList.clientWidth;
                    const isAtStart = scrollPos <= 10;
                    const isAtEnd = (scrollPos + sliderList.clientWidth) >= (sliderList.scrollWidth - 15);
                    
                    let currentPage = isAtEnd ? totalPages : Math.round(scrollPos / itemWidth) + 1;
                    if (currentLabel) currentLabel.textContent = currentPage;

                    [prevBtn, nextBtn].forEach(btn => {
                        if (!btn) return;
                        btn.removeAttribute('disabled');
                        btn.style.pointerEvents = "auto";
                        btn.style.cursor = "pointer";
                        btn.setAttribute('aria-hidden', 'false');
                        btn.setAttribute('tabindex', '0');

                        if (btn.name === 'next') {
                            const nextP = currentPage < totalPages ? currentPage + 1 : totalPages;
                            btn.setAttribute('aria-label', `Page ${nextP} of ${totalPages}`);
                            btn.style.opacity = isAtEnd ? "0.3" : "1";
                        } else {
                            const prevP = currentPage > 1 ? currentPage - 1 : 1;
                            btn.setAttribute('aria-label', `Page ${prevP} of ${totalPages}`);
                            btn.style.opacity = isAtStart ? "0.3" : "1";
                        }
                    });
                };

                const handleMove = (dir) => {
                    const itemWidth = allItems[0]?.clientWidth || sliderList.clientWidth;
                    sliderList.scrollBy({ left: dir === 'next' ? itemWidth : -itemWidth, behavior: 'smooth' });
                };

                nextBtn.onclick = (e) => { e.preventDefault(); e.stopPropagation(); handleMove('next'); };
                prevBtn.onclick = (e) => { e.preventDefault(); e.stopPropagation(); handleMove('prev'); };

                sliderList.onscroll = updateUI;
                updateUI(); 
            });
        };

        setInterval(fixSliderEverything, 1000);
    }
    
    function fixSlider() {
        const containerGrid = document.querySelector('.grid.product-grid');
        if (!containerGrid) return;
        
        const isMobile = window.innerWidth < 990;
        const sliders = containerGrid.querySelectorAll('.slider__slide');
        const sliderComponents = containerGrid.parentElement;
        const isSliderMobileActive = sliderComponents.getAttribute('is-slider-mobile');
        const isSliderDesktopActive = sliderComponents.getAttribute('is-slider-desktop');
        //list semantics
        if((isMobile && isSliderMobileActive === 'false') || (!isMobile && isSliderDesktopActive === 'false')) {
            containerGrid.setAttribute('role', 'list');
            sliders.forEach(element => {
                element.setAttribute('role', 'listitem');
                element.removeAttribute('aria-label');
                element.querySelectorAll('a').forEach(link => {
                link.setAttribute('tabindex', '0');
                link.setAttribute('aria-hidden', 'false');
                });
            });
            return
        } 
        //slider semantics
        else if((isMobile && isSliderMobileActive === 'true') || (!isMobile && isSliderDesktopActive === 'true'))  {
            containerGrid.setAttribute('role', 'region');
            const sectionContainer = containerGrid.closest('.section, .collection, .featured-collection');
            const titleElement = sectionContainer ? sectionContainer.querySelector('.collection__title h2') : null;

            if (titleElement) {
                if (!titleElement.id) {
                    const uniqueId = 'SliderTitle-' + Math.random().toString(36).substr(2, 9);
                    titleElement.id = uniqueId;
                }
                
                containerGrid.setAttribute('aria-labelledby', titleElement.id);
                containerGrid.removeAttribute('aria-label');
            } else {
                containerGrid.setAttribute('aria-label', 'Product Carousel');
            }

            const slides = containerGrid.querySelectorAll('.slider__slide');
            slides.forEach((slide, index) => {
                slide.setAttribute('role', 'group');
                
                slide.setAttribute('aria-label', `Slide ${index + 1} of ${slides.length}`);

                const links = slide.querySelectorAll('a');
                if (slide.getAttribute('aria-hidden') === 'true') {
                    links.forEach(link => {
                        link.setAttribute('tabindex', '-1');
                        link.setAttribute('aria-hidden', 'true');
                    });
                } else {
                    links.forEach(link => {
                        link.setAttribute('tabindex', '0');
                        link.setAttribute('aria-hidden', 'false');
                    });
                }
            });
        }

        function initSlideObserver() {
            if (this.slideObserver) return;

            this.slideObserver = new IntersectionObserver(
                entries => {
                    entries.forEach(entry => {
                        const item = entry.target;
                        const linkElements = item.querySelectorAll('a');

                        if (entry.isIntersecting) {
                            linkElements.forEach(element => {
                                element.setAttribute('aria-hidden', 'false');
                                element.removeAttribute('tabindex');
                            });
                            item.setAttribute('aria-hidden', 'false');
                            item.removeAttribute('tabindex');
                        } else {
                            item.setAttribute('aria-hidden', 'true');
                            linkElements.forEach(element => {
                                element.setAttribute('aria-hidden', 'true');
                                element.setAttribute('tabindex', '-1');
                            });
                        }
                    });
                },
                {
                    root: this.slider,
                    threshold: 0.6
                }
            );

            

            sliders.forEach((item, index) => {
                this.slideObserver.observe(item);
            });
        }

        initSlideObserver()
    }

    function fixSliderSemanticsForMobileAtProductInfoPage() {
        const isMobile = window.innerWidth <= 767;
        if(!isMobile) return

        document.querySelectorAll('.pagefly-list-up').forEach((element, indexParent) => {
            const slider = element.querySelector('.pf-slider');

            if (slider) {
                setTimeout(() => {
                    slider.setAttribute('role', 'region');
                    console.log('parent index', indexParent)
                    slider.setAttribute('aria-label', indexParent === 1 ? 'Product Features' : 'Product Reviews');
                }, 100);

            }

            const items = element.querySelectorAll('.pf-slide');
            items.forEach((slide, index) => {
                setTimeout(() => {
                    slide.setAttribute('role', 'group');
                }, 100);
                slide.setAttribute('aria-label', `Slide ${index + 1} of ${items.length}`);
                new MutationObserver(() => {
                    const isVisible = slide.classList.contains('is-visible');
                    slide.setAttribute('aria-hidden', String(!isVisible))
                }).observe(slide, { attributes: true, attributeFilter: ['class'] });
            });
        });

    }
    ////Execution zone
    restoreSliderPaginationButtonsActions();
    fixSlider();
    fixSliderSemanticsForMobileAtProductInfoPage();
    //////////////////////////////////////////////////////////////// GLOBAL - END ///////////////////////////////////////////////////////////////////

});